export default __webpack_public_path__ + "static/media/fragrnace-inner-img.3dc920df.png";